var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutubeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 13,
    viewBox: "0 0 18 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.6679 0.777871C16.4022 0.973083 16.9805 1.54827 17.1768 2.27872C17.5335 3.60256 17.5335 6.36476 17.5335 6.36476C17.5335 6.36476 17.5335 9.12687 17.1768 10.4508C16.9805 11.1812 16.4022 11.7564 15.6679 11.9517C14.3371 12.3064 9.00013 12.3064 9.00013 12.3064C9.00013 12.3064 3.66321 12.3064 2.3323 11.9517C1.59795 11.7564 1.01962 11.1812 0.823354 10.4508C0.466797 9.12687 0.466797 6.36476 0.466797 6.36476C0.466797 6.36476 0.466797 3.60256 0.823354 2.27872C1.01962 1.54827 1.59795 0.973083 2.3323 0.777871C3.66321 0.423096 9.00013 0.423096 9.00013 0.423096C9.00013 0.423096 14.3371 0.423096 15.6679 0.777871ZM7.40015 4.03971V9.20637L11.6668 6.62314L7.40015 4.03971Z",
    fill: ""
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeIcon);
export default __webpack_public_path__ + "static/media/youtube-icon.d3c781ce602a1ecd5722790597e8dadc.svg";
export { ForwardRef as ReactComponent };